<script setup>
import { useTemplateRef, onMounted, watch } from 'vue';

const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    }
});

const dialog = useTemplateRef('dialog');
const emit = defineEmits(['close']);

const close = () => {
    emit('close');
};

onMounted(() => {
	if (props.show) {
		dialog.value.showModal();
	}
});

watch(
    () => props.show,
    () => {
        if (props.show) {
            dialog.value.showModal();
        } else {
            dialog.value.close();
        }
    },
);
</script>

<template>
	<dialog ref="dialog">
		<form class="close" method="dialog" @submit="close">
			<button value="close">
				<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M8.93359 1.49609L5.65234 4.77734L8.90625 8.03125C9.17969 8.27734 9.17969 8.6875 8.90625 8.93359C8.66016 9.20703 8.25 9.20703 8.00391 8.93359L4.72266 5.67969L1.46875 8.93359C1.22266 9.20703 0.8125 9.20703 0.566406 8.93359C0.292969 8.6875 0.292969 8.27734 0.566406 8.00391L3.82031 4.75L0.566406 1.49609C0.292969 1.25 0.292969 0.839844 0.566406 0.566406C0.8125 0.320312 1.22266 0.320312 1.49609 0.566406L4.75 3.84766L8.00391 0.59375C8.25 0.320312 8.66016 0.320312 8.93359 0.59375C9.17969 0.839844 9.17969 1.25 8.93359 1.49609Z" fill="#1E2120"/>
				</svg>
			</button>
		</form>

		<slot/>
	</dialog>
</template>
